(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-editorial-hero-ba"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.lp-editorial-hero-ba__comparison').forEach((comparison) => {
    const beforeTag = comparison.querySelector('.lp-editorial-hero-ba__tag--before');
    const afterTag = comparison.querySelector('.lp-editorial-hero-ba__tag--after');
    if (!beforeTag && !afterTag) return;

    const isVertical = comparison.getAttribute('data-cursor-direction') === 'vertical';
    const hideThreshold = parseFloat(
      getComputedStyle(comparison).getPropertyValue('--lp-editorial-hero-ba-label-hide')
    ) || 7;

    const getCursorPos = () => {
      const inlinePos = comparison.style.getPropertyValue('--image-comparison--cursor-pos').trim();
      const computedPos = getComputedStyle(comparison).getPropertyValue('--image-comparison--cursor-pos').trim();
      return parseFloat(inlinePos || computedPos) || 50;
    };

    const updateLabels = () => {
      const pos = getCursorPos();

      if (beforeTag) {
        const hideBefore = pos <= hideThreshold;
        beforeTag.classList.toggle('is-hidden', hideBefore);
        beforeTag.toggleAttribute('hidden', hideBefore);
      }

      if (afterTag) {
        const hideAfter = pos >= 100 - hideThreshold;
        afterTag.classList.toggle('is-hidden', hideAfter);
        afterTag.toggleAttribute('hidden', hideAfter);
      }
    };

    updateLabels();

    new MutationObserver(updateLabels).observe(comparison, {
      attributes: true,
      attributeFilter: ['style']
    });

    if (!isVertical && afterTag) {
      comparison.addEventListener('transitionend', (event) => {
        if (event.target.classList?.contains('image-comparison--after')) {
          updateLabels();
        }
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-editorial-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.lp-editorial-hero__comparison').forEach((comparison) => {
    const beforeTag = comparison.querySelector('.lp-editorial-hero__tag--before');
    const afterTag = comparison.querySelector('.lp-editorial-hero__tag--after');
    if (!beforeTag && !afterTag) return;

    const isVertical = comparison.getAttribute('data-cursor-direction') === 'vertical';
    const hideThreshold = parseFloat(
      getComputedStyle(comparison).getPropertyValue('--lp-editorial-hero-label-hide')
    ) || 7;

    const getCursorPos = () => {
      const inlinePos = comparison.style.getPropertyValue('--image-comparison--cursor-pos').trim();
      const computedPos = getComputedStyle(comparison).getPropertyValue('--image-comparison--cursor-pos').trim();
      return parseFloat(inlinePos || computedPos) || 50;
    };

    const updateLabels = () => {
      const pos = getCursorPos();

      if (beforeTag) {
        const hideBefore = pos <= hideThreshold;
        beforeTag.classList.toggle('is-hidden', hideBefore);
        beforeTag.toggleAttribute('hidden', hideBefore);
      }

      if (afterTag) {
        const hideAfter = pos >= 100 - hideThreshold;
        afterTag.classList.toggle('is-hidden', hideAfter);
        afterTag.toggleAttribute('hidden', hideAfter);
      }
    };

    updateLabels();

    new MutationObserver(updateLabels).observe(comparison, {
      attributes: true,
      attributeFilter: ['style']
    });

    if (!isVertical && afterTag) {
      comparison.addEventListener('transitionend', (event) => {
        if (event.target.classList?.contains('image-comparison--after')) {
          updateLabels();
        }
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-heritage-compare"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.lp-heritage-ba__comparison').forEach((comparison) => {
    const beforeTag = comparison.querySelector('.lp-heritage-ba__tag--before');
    const afterTag = comparison.querySelector('.lp-heritage-ba__tag--after');
    if (!beforeTag && !afterTag) return;

    const isVertical = comparison.getAttribute('data-cursor-direction') === 'vertical';
    const hideThreshold = parseFloat(
      getComputedStyle(comparison).getPropertyValue('--lp-heritage-ba-label-hide')
    ) || 7;

    const getCursorPos = () => {
      const inlinePos = comparison.style.getPropertyValue('--image-comparison--cursor-pos').trim();
      const computedPos = getComputedStyle(comparison).getPropertyValue('--image-comparison--cursor-pos').trim();
      return parseFloat(inlinePos || computedPos) || 50;
    };

    const updateLabels = () => {
      const pos = getCursorPos();

      if (beforeTag) {
        const hideBefore = pos <= hideThreshold;
        beforeTag.classList.toggle('is-hidden', hideBefore);
        beforeTag.toggleAttribute('hidden', hideBefore);
      }

      if (afterTag) {
        const hideAfter = pos >= 100 - hideThreshold;
        afterTag.classList.toggle('is-hidden', hideAfter);
        afterTag.toggleAttribute('hidden', hideAfter);
      }
    };

    updateLabels();

    new MutationObserver(updateLabels).observe(comparison, {
      attributes: true,
      attributeFilter: ['style']
    });

    if (!isVertical && afterTag) {
      comparison.addEventListener('transitionend', (event) => {
        if (event.target.classList?.contains('image-comparison--after')) {
          updateLabels();
        }
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sj-shopable-reels"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.sj-swiper', {
    resizeObserver: false,
    slidesPerView: 1.2,
    centeredSlides: true,
    spaceBetween: 20,
    grabCursor: true,
    loop: true,
    speed: 500,
    slideToClickedSlide: true,
    freeMode: false,
    freeModeSticky: false,
    resistanceRatio: 0,
    breakpoints: {
      768: { 
        slidesPerView: 3,
        centeredSlides: true,
        spaceBetween: 10,
        freeMode: false,
      },
      1100: { 
        slidesPerView: 4,
        centeredSlides: true,
        spaceBetween: 20,
        freeMode: true,
        freeModeSticky: true,
      },
      1400: { 
        slidesPerView: 5,
        centeredSlides: true,
        spaceBetween: 20,
        freeMode: true,
        freeModeSticky: true,
      }
    },

    on: {
      init:syncVideos,
      slideChangeTransitionEnd: syncVideos
    }
  });

  function syncVideos() {
  document.querySelectorAll('.sj-reels .sj-swiper').forEach(swiper => {
    const isMuted = swiper.classList.contains('is-muted');

    swiper.querySelectorAll('.sj-slide').forEach(slide => {
      const video = slide.querySelector('video');
      if (!video) {
        slide.classList.remove('is-playing');
        slide.classList.add('is-paused');
        return;
      }

      const isActive = slide.classList.contains('swiper-slide-active');

      if (isActive) {
        // Safety: pause first to cancel any pending play()
        video.pause();

        video.muted = isMuted;

        video.play().then(() => {
          // Guard: ensure slide is STILL active
          if (!slide.classList.contains('swiper-slide-active')) {
            video.pause();
            video.currentTime = 0;
          }
        }).catch(() => {});

        slide.classList.add('is-playing');
        slide.classList.remove('is-paused');
      } else {
        // HARD STOP inactive videos
        video.pause();
        video.currentTime = 0;
        video.muted = true;

        slide.classList.remove('is-playing');
        slide.classList.add('is-paused');
      }
    });
  });
}

  // Mute / unmute toggle
  document.querySelectorAll('.sj-sound-control').forEach(btn => {
  btn.addEventListener('click', e => {
    e.stopPropagation();

    // 🔍 scope everything to THIS slider only
    const swiper = btn.closest('.sj-swiper');
    if (!swiper) return;

    const clickedSlide = btn.closest('.sj-slide');
    const clickedVideo = clickedSlide.querySelector('video');
    if (!clickedVideo) return;

    // Flip based on clicked slide's current state
    const newMutedState = !clickedVideo.muted;

    // Apply to ALL videos inside this swiper
    swiper.querySelectorAll('.sj-slide video').forEach(video => {
      video.muted = newMutedState;
    });

    // Update state ONLY on this swiper
    swiper.classList.remove('is-muted', 'is-unmuted');
    swiper.classList.add(newMutedState ? 'is-muted' : 'is-unmuted');
  });
});




});

  } catch(e) { console.error(e); }
})();
})();
